import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress'; // ⬅️ این خط رو اضافه کردیم
import Profile from '../../components/project/Profile';
import AddProjectForm from '../../components/project/AddProjectForm';
import ProjectCard from '../../components/project/ProjectCard';
import GridSkeleton from '../../components/project/GridSkeleton';
import Subscription from '../../components/project/Subscription';
import Tutorial from '../../components/project/Tutorial';

// NProgress
import NProgress from '../../utils/nprogress';

const ProjectPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('projects');
  const [user, setUser] = useState(null);

  // گرفتن لیست پروژه‌ها
  const loadProjects = async () => {
    try {
      const res = await fetch('/db/get-projects.php');
      const result = await res.json();

      if (result.status === 'success') {
        setProjects(result.projects || []);
      } else {
        setProjects([]);
      }
    } catch (err) {
      console.error("خطا در گرفتن پروژه:", err);
    } finally {
      setTimeout(() => setLoading(false), 3000); // شبیه‌سازی لود شدن
    }
  };

  // گرفتن اطلاعات کاربر
  const loadUser = async () => {
    try {
      const res = await fetch('/db/get-user.php');
      const result = await res.json();

      if (result.status === 'success') {
        setUser(result.user);
      }
    } catch (err) {
      console.error("خطا در گرفتن اطلاعات کاربر:", err);
    }
  };



  // مدیریت تغییر به ثبت‌نام
  const navigate = (tab) => {
    NProgress.start();
    setActiveTab(tab);
    window.history.pushState({}, '', `/project/${tab}`);
    setTimeout(() => NProgress.done(), 900);
  };



  // تشخیص تب فعلی از URL
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/project/profile')) {
      setActiveTab('profile');
    } else if (path.includes('/project/subscription')) {
      setActiveTab('subscription');
    } else if (path.includes('/project/tutorial')) {
      setActiveTab('tutorial');
    } else if (path.includes('/project/add-project')) {
      setActiveTab('add-project');
    } else {
      setActiveTab('projects');
    }

    setLoading(true);
    loadProjects();
    loadUser();
  }, []);

  // به‌روزرسانی URL وقتی تب عوض شد
  useEffect(() => {
    window.history.replaceState({}, '', `/project/${activeTab}`);
  }, [activeTab]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        minHeight: '100vh',
        backgroundColor: '#10172A',
        color: 'white',
        padding: { xs: '1rem', md: '2rem' },
        justifyContent: 'center',
        alignItems: { xs: 'stretch', md: 'center' },
        gap: { xs: 2, md: 0 }
      }}
    >
      {/* منو کناری */}
      <Box
        sx={{
          width: { xs: '100%', md: '18%' },
          height: { md: '600px' },
          backgroundColor: 'rgba(255, 255, 256, 0.05)',
          backdropFilter: { md: 'blur(10px)' },
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(97, 218, 251, 0.1)',
          padding: '1rem',
          position: { md: 'sticky' },
          top: { md: '2rem' },
          mb: { xs: 2, md: 0 }
        }}
      >
        {/* Avatar + Profile */}
        {user && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 2,
              borderBottom: '1px solid #444',
              mb: 2
            }}
          >
            <Box
              component="img"
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(`${user.name} ${user.last_name}`)}&background=303B4B&color=fff`}
              alt="آواتار"
              sx={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                mb: 1
              }}
            />
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              {user.name} {user.last_name}
            </Typography>
            <Typography variant="caption" sx={{ color: '#aaa' }}>
              {user.email}
            </Typography>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => navigate('profile')}
              sx={{ mt: 2, fontWeight: 'bold' }}
            >
              پروفایل کاربری
            </Button>
          </Box>
        )}

        {/* منوی اصلی */}
        <Box>
          <Typography variant="h6" gutterBottom align="center" sx={{ pb: 1 }}>
            منوی مدیریت
          </Typography>

          <Button
            fullWidth
            variant={activeTab === 'projects' ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => navigate('projects')}
            sx={{ mb: { xs: 1.5, md: 2 }, fontWeight: 'bold' }}
          >
            👀 &nbsp; پروژه‌های من
          </Button>

          <Button
            fullWidth
            variant={activeTab === 'add-project' ? 'contained' : 'outlined'}
            color="secondary"
            onClick={() => navigate('add-project')}
            sx={{ fontWeight: 'bold', color: activeTab === 'add-project' ? 'black' : 'white' }}
          >
            ➕ &nbsp; افزودن پروژه
          </Button>

          <Button
            fullWidth
            variant={activeTab === 'subscription' ? 'contained' : 'outlined'}
            color="info"
            onClick={() => navigate('subscription')}
            sx={{ mt: 2, fontWeight: 'bold', color: activeTab === 'subscription' ? 'white' : 'inherit' }}
          >
            💰 &nbsp; اشتراک
          </Button>

          <Button
            fullWidth
            variant={activeTab === 'tutorial' ? 'contained' : 'outlined'}
            color="warning"
            onClick={() => navigate('tutorial')}
            sx={{ mt: 2, fontWeight: 'bold', color: activeTab === 'tutorial' ? 'white' : 'inherit' }}
          >
            📘 &nbsp; آموزش
          </Button>
        </Box>

        {/* دکمه خروج */}
        <Box sx={{ mt: 'auto', pt: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            color="error"
            onClick={() => {
              fetch('/db/logout.php', { method: 'POST', credentials: 'include' })
                .then(() => window.location.replace('/auth/login'));
            }}
            sx={{ fontWeight: 'bold' }}
          >
            خروج از حساب
          </Button>
        </Box>
      </Box>

      {/* باکس اصلی - 50% صفحه */}
      <Box
        sx={{
          flex: 1,
          maxWidth: '800px',
          width: '100%'
        }}
      >
        {/* نوار پیشرفت بالای صفحه */}
        {loading && <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }} />}

        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: '16px',
            backgroundColor: '#2d2d2d',
            backgroundImage: 'linear-gradient(145deg, #303B4B, #252f3e)',
            border: '1px solid #3a475a',
            boxShadow: '0 8px 20px rgba(48, 59, 75, 0.3)',
            overflow: 'hidden',
            minHeight: { xs: 'auto', md: '700px' },
            display: 'grid',
            alignContent: 'center'
          }}
        >
          {/* عنوان هر تب */}
          {activeTab === 'projects' && (
            <Typography variant="h5" gutterBottom align="center" pb={2}>
              پروژه‌های من
            </Typography>
          )}

          {activeTab === 'add-project' && (
            <Typography variant="h5" gutterBottom align="center" pb={2}>
              افزودن پروژه
            </Typography>
          )}

          {activeTab === 'profile' && user && (
            <Typography variant="h5" gutterBottom align="center" pb={2}>
              پروفایل کاربری
            </Typography>
          )}

          {activeTab === 'subscription' && (
            <Typography variant="h5" gutterBottom align="center" pb={2}>
              اشتراک ها
            </Typography>
          )}

          {activeTab === 'tutorial' && (
            <Typography variant="h5" gutterBottom align="center" pb={2}>
              آموزش استفاده
            </Typography>
          )}

          {/* محتوای dynamic */}
          {activeTab === 'projects' && (
            <>
              {loading ? (
                <GridSkeleton />
              ) : projects.length > 0 ? (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                    gap: 2,
                    mt: 2,
                    maxHeight: { xs: 'none', md: '490px' },
                    overflowY: { xs: 'visible', md: 'auto' },
                    '&::-webkit-scrollbar': { width: 8 },
                    '&::-webkit-scrollbar-track': { background: '#333' },
                    '&::-webkit-scrollbar-thumb': { background: '#61dafb', borderRadius: 4 }
                  }}
                >
                  {projects.map((project) => (
                    <ProjectCard key={project.id} project={project} />
                  ))}
                </Box>
              ) : (
                <Typography align="center" sx={{ mt: 2, color: '#aaa' }}>
                  شما هنوز هیچ پروژه ای ایجاد نکرده اید ! از منوی سمت راست "افزودن پروژه" رو بزن
                </Typography>
              )}
            </>
          )}

          {activeTab === 'add-project' && (
            <AddProjectForm onAddSuccess={() => {
              loadProjects();
              navigate('projects');
            }} />
          )}

          {activeTab === 'profile' && user && <Profile user={user} />}
          {activeTab === 'subscription' && <Subscription />}
          {activeTab === 'tutorial' && <Tutorial />}
        </Paper>
      </Box>
    </Box>
  );
};

export default ProjectPage;